export const lssLangAr = {
    contact: {
        contactList: 'Contact List',
        name: 'Name',
        phone: 'Phone',
        close: 'Close',  
        check: 'Check',
        searchName: 'Search Name',
        lastDialTime: 'last dial time',
        numberOfCalls: 'number of calls'
      },
};
